import { useMemo } from 'react';

export const BooleanFormat = {
  'true': true,
  'false': false
};

export const valueWithFormat = (v = '') => {
  const value = v.trim();
  const isNumber = !isNaN(+ value);
  if (isNumber)
    return Number(value);
  else if (['true', 'false'].includes(value))
    return BooleanFormat[value];
  else
    return value;
};

/**
 * @param { Window } window 
 * @returns { { map: Map<string, string | number>; json: { version?: number, tab?: string, taskId?: string }; } } query
 */
export const useQueryParams = ({ location }) => {
  const { map, json } = useMemo(() => {
    const query = new Map();
    const queryJson = {};
    const urlParams = new URLSearchParams((location && location.search) || '');
    const entries = [...urlParams.entries()];

    entries.forEach(([key, value]) => {
      const valueList = value.split(',');
      const formattedValues = valueList.map(valueWithFormat);
      if(query.has(key))
        query.set(key, [...query.get(key), ...formattedValues]);
      else
        query.set(key, formattedValues);
    });

    query.forEach((value = [], key = '', map = Map()) => {
      let nextValue;
      if (value.length === 1) {
        nextValue = value[0];
      } else {
        nextValue = [...new Set(value)];
      }
      map.set(key, nextValue);
      queryJson[key] = nextValue;
    });

    return { map: query, json: queryJson };
  }, [location]);

  return { map, json };
};

export default useQueryParams;
